import { buildMaterialIconSvg } from './material-icons';

/** Tipos de icono semántico que el funder puede personalizar desde el backoffice (styles.<tipo>Icon). */
export type StatusIconType = 'error' | 'warning' | 'success' | 'info';

/** Icono de Material Design por defecto para cada tipo (nombres de MATERIAL_ICONS). */
export const STATUS_ICON_DEFAULTS: Record<StatusIconType, string> = {
  error: 'highlight_off',
  warning: 'warning',
  success: 'check_circle',
  info: 'info',
};

/** Color por defecto de cada icono cuando se pinta fuera del flujo (p. ej. en los modales). */
export const STATUS_ICON_COLORS: Record<StatusIconType, string> = {
  error: '#dc2626',
  warning: '#f97316',
  success: '#16a34a',
  info: '#2563eb',
};

/** Valores de styles.<tipo>Icon que significan "usar el icono por defecto" (no son una imagen cargada). */
const DEFAULT_ICON_KEYWORDS = new Set(['success', 'error', 'warning', 'info', 'question']);

export function isDefaultIconKeyword(icon: string | null | undefined): boolean {
  return !icon || DEFAULT_ICON_KEYWORDS.has(icon);
}

/** URL de la imagen que el funder ha cargado para ese tipo de icono, o null si debe usarse el icono por defecto. */
export function getCustomStatusIconUrl(styles: any, type: StatusIconType): string | null {
  const icon = styles?.[`${type}Icon`];
  return isDefaultIconKeyword(icon) ? null : icon;
}

/** SVG del icono por defecto, coloreado, como data URI (para contextos fuera de Angular, como SweetAlert). */
export function getDefaultStatusIconDataUri(type: StatusIconType): string {
  const svg = buildMaterialIconSvg(STATUS_ICON_DEFAULTS[type], STATUS_ICON_COLORS[type]);
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
